module.exports = __webpack_public_path__ + "static/media/img-4.7526fe8c.jpg";